import { Danger } from "iconsax-reactjs"
import { ProcessorKey } from "../../../shared/assets/svg"
import { BodyText, Button, HeadingText, Input } from "../../../shared/ui"
import { useNavigate } from "react-router-dom"
import { useMutation } from "@tanstack/react-query"
import { verifyMfaBackupCodeService } from "../service"
import { VerifyMfaDataType } from "../types"
import { useState } from "react"
import { toast } from "sonner"
import { PAGES } from "../../../shared/lib/pageUrlConstants"
import { useDispatch } from "react-redux"
import { login } from "../../../redux/slices/authSlice"

const BackupCode = () => {
  const [value, setValue] = useState("")
  const [errorMsg, setErrorMsg] = useState("")
  const navigate = useNavigate()


  const { mutateAsync, isPending } = useMutation({ mutationFn: (data: VerifyMfaDataType) => verifyMfaBackupCodeService(data) })
  const dispatch = useDispatch()

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const data: VerifyMfaDataType = {
      code: value
    }
    try {
      const res = await mutateAsync(data)
      toast.success(res?.message)
      localStorage.setItem("token", res?.data?.token);
      dispatch(login(res?.data));
      window.location.replace(PAGES.dashboard);
    } catch (error: any) {
      setErrorMsg(error?.response?.data?.message || error?.message || "Something went wrong")
      toast.error(error?.response?.data?.message || error?.message || "Something went wrong", { position: "top-right" })
    }
  }

  return (
    <div className="bg-white md:max-w-[628px]   mx-auto w-11/12 rounded-[32px] p-4 md:p-[32px] shadow-[0px_4px_40px_rgba(0,0,0,0.02)] border border-primary-80">
      <div className="flex flex-col items-start gap-6">
        <div className='p-0 relative h-12'>
          <ProcessorKey className="absolute -top-5 -left-6" />
        </div>

        <div className="space-y-1">
          <HeadingText className="text-2xl md:text-3xl font-semibold leading-tight">
            Enter backup verification code
          </HeadingText>
          <BodyText className="text-gray-80 text-sm font-[350]">
            Provide your 12-digit backup verification code given to you when <br className="md:block hidden" /> you set up your 2FA.
          </BodyText>
        </div>

        <form className="w-full space-y-4 mt-2" onSubmit={handleSubmit}>
          <div className="space-y-2">
            <Input
              type="text"
              placeholder="Backup verification code"
              name="backupCode"
              value={value}
              onChange={(e) => setValue(e.target.value)}
              className="h-[56px] px-4 placeholder:text-gray-70 rounded-[8px] bg-primary-80 border-none focus-visible:ring-1 focus-visible:ring-primary-20"
            />
            {errorMsg && <p className="text-error-30 flex items-center gap-1 font-[350] text-xs"><Danger size={20} /> <span>{errorMsg}</span></p>}
          </div>


          <div className="flex items-center justify-between gap-5 pt-2">
            <a
              href="mailto:admin@tradevu.com"
              className="text-sm font-[450] hover:text-gray-30 text-primary-20 transition-colors"
              target="_blank"
              rel="noreferrer"
            >
              Contact an Admin
            </a>

            <div className="flex items-center justify-between gap-5">
              <Button
                onClick={() => navigate(-1)}
                className="text-sm font-[450] border-none text-gray-30 hover:text-primary-20 transition-colors"
                variant="outline"
              >
                Go back
              </Button>
              <Button
                type="submit"
                size="lg"
                disabled={isPending || !value || value.length !== 12}
                className="!h-[40px] rounded-[8px] text-base font-[450] bg-[#161827] hover:bg-[#20243a]"
              >
                {isPending ? "Loading..." : "Verify"}
              </Button>
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}

export default BackupCode
